import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { Button } from 'react-bootstrap';

import { BaseField, DollarField } from '../../fields/index';
import { toDollarFormat, openInNewTab } from '../../../utils';
import { getBonusApprovalsLink } from '../links';
import { APPROVED, FINALIZED } from '../constants';

const propTypes = exact({
  memberPath: PropTypes.string.isRequired,
  fullname: PropTypes.string.isRequired,
  totalBonusOpportunity: PropTypes.number.isRequired,
  /* Could be null- being unaproved */
  totalApprovedAmount: PropTypes.number,

  bonusMonth: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
  supervisorId: PropTypes.number.isRequired,

  bonusMonthState: PropTypes.string.isRequired,
  managerNotes: PropTypes.string,
  isUserActive: PropTypes.bool.isRequired,

  districtName: PropTypes.string.isRequired,
  departmentName: PropTypes.string.isRequired,
  rowColor: PropTypes.string.isRequired,

  totalPerDiemAmount: PropTypes.number.isRequired,
});

const selector = formValueSelector('bonusSummaryForm');

const handleViewUserMonthBonus = (userId, bonusMonth, supervisorId) => {
  const url = getBonusApprovalsLink(userId, bonusMonth, supervisorId);
  openInNewTab(url);
};

const UserSummaryBonusField = (props) => {
  const {
    memberPath,
    fullname,
    totalBonusOpportunity,
    totalApprovedAmount,
    supervisorId,
    bonusMonth,
    userId,
    bonusMonthState,
    isUserActive,
    managerNotes,
    districtName,
    departmentName,
    rowColor,
    totalPerDiemAmount,
  } = props;


  const isDisabled = (bonusMonthState !== APPROVED || !isUserActive);
  const isNotFinalized = (bonusMonthState !== FINALIZED);
  return (
    <tr style={{ backgroundColor: rowColor }}>
      <td>
        {fullname}
      </td>
      <td>{districtName}</td>
      <td>{departmentName}</td>
      <td>
        {toDollarFormat(totalBonusOpportunity)}
      </td>
      <td>
        {toDollarFormat(totalPerDiemAmount)}
      </td>
      <td>
        {toDollarFormat(totalApprovedAmount)}
      </td>
      <td>
        {managerNotes}
      </td>
      <td>
        <DollarField
          name={`${memberPath}.final_bonus_amount`}
          label={null}
          componentProps={{ disabled: (isDisabled) ? 'disabled' : '' }}
        />
      </td>
      <td>
        <BaseField
          name={`${memberPath}.final_notes`}
          label={null}
          componentProps={{ disabled: (isDisabled) ? 'disabled' : '' }}
        />
      </td>
      <td>
        {isNotFinalized
          && (
          <Button
            bsStyle="info"
            onClick={() => {
              return handleViewUserMonthBonus(userId, bonusMonth, supervisorId);
            }}
          >
            View
          </Button>
          )}
      </td>
    </tr>
  );
};


UserSummaryBonusField.propTypes = propTypes;

const enhance = connect((state, ownProps) => {
  const user = selector(state, `${ownProps.memberPath}.user`);
  const userId = user.id;
  const isUserActive = user.active;

  const supervisorId = (user.supervisor) ? user.supervisor.id : 0;
  const fullname = selector(state, `${ownProps.memberPath}.user.fullname`);
  const districtName = selector(state, `${ownProps.memberPath}.district.name`);
  const departmentName = selector(state, `${ownProps.memberPath}.department.name`);

  const totalApprovedAmount = selector(state, `${ownProps.memberPath}.approved_bonus_amount`);
  const totalBonusOpportunity = selector(state, `${ownProps.memberPath}.total_bonus_opportunity`);
  const totalPerDiemAmount = selector(state, `${ownProps.memberPath}.total_per_diem_amount`);

  const bonusMonth = selector(state, `${ownProps.memberPath}.month_bonus.month.iso8601`);
  const bonusMonthState = selector(state, `${ownProps.memberPath}.state`);

  const managerNotes = selector(state, `${ownProps.memberPath}.manager_notes`);
  const rowColor = selector(state, `${ownProps.memberPath}.color`);

  return {
    fullname,
    totalBonusOpportunity,
    supervisorId,
    bonusMonth,
    userId,
    totalApprovedAmount,
    bonusMonthState,
    isUserActive,
    managerNotes,
    districtName,
    departmentName,
    rowColor,
    totalPerDiemAmount,
  };
}, {});

export default enhance(UserSummaryBonusField);
